import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addcooperationList from "./components/addcooperationList";
export default {
  name: "cooperationList",
  mixins: [loadMoreList, serchSelect],
  components: {
    addcooperationList: addcooperationList
  },
  data: function data() {
    return {
      pagingReqFn: "payConfigurationCooperationList",
      pagingReqValue: "",
      drawer: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    del: function del(data) {
      var _this = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'payConfigurationCooperationDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};